import(/* webpackMode: "eager", webpackExports: ["MVFooter"] */ "C:\\manish-works\\touches\\lokbharti\\Lokbharati\\app\\mv-tutorials\\components\\footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MVHeader"] */ "C:\\manish-works\\touches\\lokbharti\\Lokbharati\\app\\mv-tutorials\\components\\header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AboutSection"] */ "C:\\manish-works\\touches\\lokbharti\\Lokbharati\\components\\about-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BirthdaySection"] */ "C:\\manish-works\\touches\\lokbharti\\Lokbharati\\components\\birthday-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroSection"] */ "C:\\manish-works\\touches\\lokbharti\\Lokbharati\\components\\hero-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NewsSection"] */ "C:\\manish-works\\touches\\lokbharti\\Lokbharati\\components\\news-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TestimonialSection"] */ "C:\\manish-works\\touches\\lokbharti\\Lokbharati\\components\\testimonial-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VisitorCount"] */ "C:\\manish-works\\touches\\lokbharti\\Lokbharati\\components\\visitor-count.tsx");
;
import(/* webpackMode: "eager" */ "C:\\manish-works\\touches\\lokbharti\\Lokbharati\\node_modules\\next\\dist\\client\\image-component.js");
